import { connect } from "react-redux";
// Router
import { withRouter } from "react-router-dom";

import ErrorDialog from "components/ErrorDialog";

// Action
import { closeErrorDialog } from "redux/modules/errorDialog";
// Utils
import history from "utils/history";
import { isAdmin, isCustomerAdmin } from "utils/formatter";

const mapStateToProps = state => ({ errorDialog: state.errorDialog });

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClose: () => dispatch(closeErrorDialog()),
  historyPush: path => history.push(path, ownProps),
  backToHome: () => {
    dispatch(closeErrorDialog());

    if (isAdmin()) {
      history.push("/customer_list", ownProps);
    } else if (isCustomerAdmin()) {
      history.push("/survey_list", ownProps);
    }

    window.location.reload();
  },
  windowClose: () => {
    // ウィンドウを閉じる
    window.close();
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ErrorDialog)
);



// WEBPACK FOOTER //
// ./src/containers/ErrorDialogContainer.js